var _path, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 42.1666C31 34.5 38.6667 27.635 38.6667 19.1666C38.6667 10.6983 31.8017 3.83331 23.3333 3.83331C14.865 3.83331 8 10.6983 8 19.1666C8 27.635 15.6667 34.5 23.3333 42.1666Z",
    fill: "#D92D20"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_200_5480)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 19.5,
    r: 10.5,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_200_5480)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8213 17.1595V25.2724",
    stroke: "#BF3B04",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8213 19.5121L27.2845 17.1595",
    stroke: "#BF3B04",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6251 25.2724H16.7432",
    stroke: "#BF3B04",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7812 22.4105H24.5963",
    stroke: "#BF3B04",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7393 13.7276L28.6839 20.3004L29.8606 19.4151C30.2199 18.9907 30.3437 18.4207 30.1827 17.8871L29.2537 14.8554C29.0927 14.3339 28.6715 13.9216 28.1389 13.764L26.7393 13.7397V13.7276Z",
    stroke: "#BF3B04",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6701 20.5065L22.3918 20.0821L20.6577 25.0541C20.5462 25.3573 20.2614 25.5392 19.9517 25.5392C19.865 25.5392 19.7907 25.5271 19.704 25.5028C19.32 25.3694 19.1094 24.9571 19.2457 24.5812L20.6701 20.5065Z",
    fill: "#BF3B04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.373 18.0933L21.2393 18.8694L22.2302 16.0317C22.3293 15.7407 22.6142 15.5466 22.9362 15.5466C23.2583 15.5466 23.5308 15.7407 23.6298 16.0317L24.373 18.0933Z",
    fill: "#BF3B04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.244 25.5028C25.8601 25.6362 25.4389 25.4422 25.3027 25.0541L23.4199 19.8274L24.8691 19.4636L26.7023 24.569C26.8386 24.9571 26.6404 25.3694 26.244 25.5028Z",
    fill: "#BF3B04"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_200_5480",
    x: 11,
    y: 7,
    width: 25,
    height: 25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_200_5480"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.568627 0 0 0 0 0.12549 0 0 0 0 0.0941176 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_200_5480"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_200_5480",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_200_5480"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 13,
    fill: "white",
    transform: "translate(16 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRed);
export default __webpack_public_path__ + "static/media/red.1279adafc2e5d3affe0ac575b10645a8.svg";
export { ForwardRef as ReactComponent };